import React, { useState, useEffect } from "react";
import styled, { keyframes, css } from "styled-components";
import KakaoAdfit1 from "../KakaoAdfit/KakaoAdfit1";
import KakaoAdfit2 from "../KakaoAdfit/KakaoAdfit2";
import KakaoAdfit3 from "../KakaoAdfit/KakaoAdfit3";
import KakaoAdfit4 from "../KakaoAdfit/KakaoAdfit4";
import { isMobile } from "../common/style";
import { ReactComponent as Icon } from "../common/image/game/icon.svg";
import PoopImg from "../common/image/game/똥.png";
import HeartImg from "../common/image/game/하트.png";
import PersonLImg from "../common/image/game/사람(왼).png";
import PersonRImg from "../common/image/game/사람(오).png";
import { AiFillCaretLeft, AiFillCaretRight } from "react-icons/ai";

interface PoopPosition {
  top: number;
  left: number;
  display: boolean;
}

const GamePage: React.FC = () => {
  const [key, setKey] = useState(true); //true는 왼쪽, false는 오른쪽
  const [heart, setHeart] = useState(5);
  const [personPosition, setPersonPosition] = useState(-2);
  const [poops, setPoops] = useState<PoopPosition[]>([]);
  const [collidedPoopIndices, setCollidedPoopIndices] = useState<number[]>([]);
  const [result, setResult] = useState(true);
  let personright = window.matchMedia("(max-width: 830px)").matches ? 6 : 14;
  let personleft = window.matchMedia("(max-width: 830px)").matches ? -9 : -18;

  const LeftHandler = () => {
    if (personPosition > personleft) {
      setKey(true);
      setPersonPosition((prevPosition) => prevPosition - 1);
    }
  };

  const RightHandler = () => {
    if (personPosition < personright) {
      setKey(false);
      setPersonPosition((prevPosition) => prevPosition + 1);
    }
  };

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "ArrowRight") {
        if (personPosition < personright) {
          setKey(false);
          setPersonPosition((prevPosition) => prevPosition + 1);
        }
      } else if (e.key === "ArrowLeft") {
        if (personPosition > personleft) {
          setKey(true);
          setPersonPosition((prevPosition) => prevPosition - 1);
        }
      }
    };

    const handleCollision = () => {
      const personElement = document.querySelector(".person");

      if (personElement) {
        const personRect = personElement.getBoundingClientRect();

        poops.forEach((poopPosition, index) => {
          if (!collidedPoopIndices.includes(index)) {
            const poopElement = document.querySelector(`.poop${index}`);
            if (poopElement) {
              const poopRect = poopElement.getBoundingClientRect();

              let poopwidth = window.matchMedia("(max-width: 830px)").matches
                ? 30
                : 60;
              console.log(poopwidth);
              let poopheight = window.matchMedia("(max-width: 830px)").matches
                ? 27
                : 50;

              if (
                poopRect.left + poopwidth > personRect.left &&
                poopRect.left < personRect.right &&
                poopRect.bottom + poopheight > personRect.top &&
                poopRect.top < personRect.bottom
              ) {
                if (heart > 1) {
                  setCollidedPoopIndices((prevIndices) => [
                    ...prevIndices,
                    index,
                  ]);
                  setPoops((prevPoops) => {
                    const updatedPoops = [...prevPoops];
                    updatedPoops[index] = {
                      ...updatedPoops[index],
                      display: false,
                    };
                    return updatedPoops;
                  });
                  setHeart(heart - 1);
                } else {
                  setResult(false);
                }
              }
            }
          }
        });
      }
    };

    const movePoops = () => {
      const updatedPoops = poops.map((poopPosition) => {
        let pooptop = window.matchMedia("(max-width: 830px)").matches
          ? 250
          : 340;
        if (poopPosition.top < pooptop) {
          return {
            top: poopPosition.top + 25,
            left: poopPosition.left,
            display: poopPosition.display,
          };
        } else {
          return {
            top: poopPosition.top + 25,
            left: poopPosition.left,
            display: false,
          };
        }
      });
      setPoops(updatedPoops);
    };

    const movePoopsInterval = setInterval(movePoops, 100);

    const plusPoop = () => {
      let poopleft = window.matchMedia("(max-width: 830px)").matches
        ? 260
        : 660;
      let poopleftmin = window.matchMedia("(max-width: 830px)").matches
        ? 0
        : 360;
      const newPoopPosition = {
        top: 0,
        left: Math.floor(Math.random() * poopleft) - poopleftmin,
        display: true,
      };

      setPoops((prevPoops) => [...prevPoops, newPoopPosition]);
    };

    const plusPoopInterval = setInterval(
      plusPoop,
      Math.floor(Math.random() * 1000)
    );

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      clearInterval(movePoopsInterval);
      clearInterval(plusPoopInterval);
      handleCollision();
    };
  }, [
    collidedPoopIndices,
    heart,
    personPosition,
    personleft,
    personright,
    poops,
  ]);

  const heartImages = Array.from({ length: heart }, (_, index) => (
    <img key={index} src={HeartImg} alt="하트" />
  ));

  return (
    <Center>
      <h1>똥 피하기 게임</h1>
      <Container>
        <SiteDiv>
          <Icon className="icon" />
        </SiteDiv>
        {result ? (
          <>
            <HeartDiv>{heartImages}</HeartDiv>
            <div>
              {poops.map((poopPosition, index) => (
                <PoopDiv
                  key={index}
                  top={poopPosition.top}
                  left={poopPosition.left}
                  display={poopPosition.display ? 1 : 0}
                  className={`poop${index}`}
                >
                  <img src={PoopImg} alt="똥" className="poop" />
                </PoopDiv>
              ))}
              <PersonDiv personPosition={personPosition}>
                {key ? (
                  <img src={PersonLImg} alt="왼쪽" className="person" />
                ) : (
                  <img src={PersonRImg} alt="오른쪽" className="person" />
                )}
              </PersonDiv>
              <BtnDiv>
                <button className="leftbuton" onClick={LeftHandler}>
                  <AiFillCaretLeft fill="#83c1fa" size={25} />
                </button>
                <button className="rightbutton" onClick={RightHandler}>
                  <AiFillCaretRight fill="#83c1fa" size={25} />
                </button>
              </BtnDiv>
            </div>
          </>
        ) : (
          <GameOverDiv result={result ? 0 : 1}>
            <h2>Game Over</h2>
            <button onClick={() => window.location.replace("/game")}>
              다시 하기
            </button>
          </GameOverDiv>
        )}
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default GamePage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #8abbe9;

    margin-top: 63px;
    margin-bottom: 50px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 20px;
    }
  }
`;

const Container = styled.div`
  width: 800px;
  height: 530px;

  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 8px solid #83c1fa;
  border-left: 8px solid #83c1fa;
  border-bottom: 8px solid #83c1fa;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.1);

  ${isMobile} {
    width: 300px;
    height: 380px;
    border-right: 4px solid #83c1fa;
    border-left: 4px solid #83c1fa;
    border-bottom: 4px solid #83c1fa;
  }
`;

const SiteDiv = styled.div`
  width: 100%;
  background: #83c1fa;

  .icon {
    width: 99.222px;
    float: right;
    padding: 8px;

    ${isMobile} {
      width: 75px;
      padding: 2px;
    }
  }
`;

const HeartDiv = styled.div`
  width: 800px;

  ${isMobile} {
    width: 300px;
  }

  img {
    float: right;
    width: 40px;
    padding: 10px 10px 3px 0;

    ${isMobile} {
      width: 20px;
      padding: 5px 5px 1px 0;
    }
  }
`;

const PoopDiv = styled.div<{ top: number; left: number; display: number }>`
  position: relative;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;

  img {
    position: absolute;
    width: 60px;
    height: 55.392px;
    display: ${(props) => (props.display ? "flex" : "none")};

    ${isMobile} {
      width: 30px;
      height: 27.7px;
    }
  }
`;

const PersonDiv = styled.div<{ personPosition: number }>`
  position: relative;
  top: 280px;
  left: ${(props) => props.personPosition * 20}px;

  ${isMobile} {
    top: 220px;
    left: ${(props) => props.personPosition * 15}px;
  }

  img {
    position: absolute;

    ${isMobile} {
      width: 50px;
    }
  }
`;

const GameOverDiv = styled.div<{ result: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 530px;

  ${isMobile} {
    height: 380px;
  }

  h2 {
    color: #8bb9e4;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 35px;
    font-weight: 700;
    animation: ${({ result }) =>
      result
        ? css`
            ${bigAnimation} 0.5s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      font-size: 23px;
    }
  }

  button {
    width: 210px;
    height: 75px;

    border-radius: 100px;
    border: 3px solid #83c1fa;
    background: #fff;

    color: #8bb9e4;
    text-align: center;
    font-family: GmarketSansBold;
    font-size: 25px;
    font-weight: 700;
    margin-top: 21px;

    cursor: pointer;

    &:hover {
      background: #e2effc;
    }

    ${isMobile} {
      width: 180px;
      height: 68px;
    }
  }
`;

const bigAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.5) translateY(-10%);
  }
`;

const BtnDiv = styled.div`
  bottom: 0;
  display: none;

  ${isMobile} {
    display: flex;
    margin-top: 288px;
  }

  button {
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e2effc;
    border: 1px solid #83c1fa;
    border-radius: 100px;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }

  .leftbutton {
    margin-left: 230px;
  }

  .rightbutton {
    margin-left: 230px;
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 50px;
  margin-right: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 50px;
  margin-left: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
  margin-top: 10px;
`;
